import DashboardPassportFileItem from "./DashboardPassportFileItem";

export default DashboardPassportFileItem;
